

import { Container } from 'shards-react';

const Loading = ()=>{

    return (
        <Container fluid  style={{marginTop:"25%"}}  >
            <div className="text-center">
            <div className="spinner-grow text-primary" role="status">
                <span className="sr-only">Loading...</span>
            </div>
            </div>
        </Container>    
    )
};

export default Loading;